import * as React from "react";
const SvgFiRrVectorCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-vector-circle_svg__a)">
      <path
        fill="#062147"
        d="M22.065 9.002a10.51 10.51 0 0 0-7.067-7.067A2 2 0 0 0 13 0h-2a2 2 0 0 0-1.998 1.935 10.51 10.51 0 0 0-7.067 7.067A2 2 0 0 0 0 11v2c0 1.081.862 1.964 1.935 1.998a10.51 10.51 0 0 0 7.067 7.067A2 2 0 0 0 11 24h2a2 2 0 0 0 1.998-1.935 10.51 10.51 0 0 0 7.067-7.067A2 2 0 0 0 24 13v-2a2 2 0 0 0-1.935-1.998M11 2h2v2h-2zM4 13H2v-2h2zm7 9v-2h2v2zm8.956-7.001a8.5 8.5 0 0 1-4.957 4.957A2 2 0 0 0 13 18h-2a2 2 0 0 0-1.999 1.956 8.5 8.5 0 0 1-4.957-4.957A2 2 0 0 0 6 13v-2a2 2 0 0 0-1.956-1.999 8.5 8.5 0 0 1 4.957-4.957A2 2 0 0 0 11 6h2a2 2 0 0 0 1.999-1.956 8.5 8.5 0 0 1 4.957 4.957A2 2 0 0 0 18 11v2c0 1.088.873 1.976 1.956 1.999M22 13h-2v-2h2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-vector-circle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVectorCircle;
